import ProfileMiniHeader from "./ProfileMiniHeader";
import { PageSerializersUsersLayout } from "types/serializers";
import CoverLayout from "layouts/CoverLayout";

export interface Props {
  user: PageSerializersUsersLayout;
  children: React.ReactNode;
}

export default function ProfileWrapper({ user, children }: Props) {
  return (
    <CoverLayout cover={user.cover}>
      <ProfileMiniHeader user={user} />

      {children}
    </CoverLayout>
  );
}
